import { SelectProps as MuiSelectProps, SelectChangeEvent } from '@mui/material';
import { ChipConfig } from '../../_components/ChipList/chipList.types';
import { withLockedPreserved } from '../../_components/ChipList/chipList.utils';
import { SelectOptionValue } from '../select.types';

interface UseLockedSelectChangeParams {
  value: MuiSelectProps['value'];
  multiple?: boolean;
  getChipConfig?: (value: SelectOptionValue) => ChipConfig | undefined;
  onChange?: MuiSelectProps['onChange'];
}

const normalizeMultipleValue = (rawValue: unknown): SelectOptionValue[] => {
  const value = rawValue as string | SelectOptionValue[];
  return typeof value === 'string' ? value.split(',') : value;
};

const useLockedSelectChange = ({
  value,
  multiple,
  getChipConfig,
  onChange,
}: UseLockedSelectChangeParams): NonNullable<MuiSelectProps['onChange']> => {
  return (event, child) => {
    if (multiple && getChipConfig) {
      const current = (value as SelectOptionValue[] | undefined) ?? [];
      const next = normalizeMultipleValue(event.target.value);
      const preserved = withLockedPreserved({
        current,
        next,
        isLocked: (item) => getChipConfig(item)?.isDeletable === false,
      });

      if (preserved.length !== next.length) {
        Object.defineProperty(event, 'target', {
          writable: true,
          value: { ...event.target, value: preserved },
        });
        onChange?.(event as SelectChangeEvent<unknown>, child);
        return;
      }
    }

    onChange?.(event, child);
  };
};

export default useLockedSelectChange;
